export default __webpack_public_path__ + "static/media/GW.5f06f727.ico";